}

if (typeof __START_DELAY === "undefined") {
  __START__();
}
